module.exports = __webpack_public_path__ + "img/medical research.3afa4216.png";